import ModuleManager from "../framework/core/module_manager";
import AppData from '../pacakge/public/const/app_data';
import HallServer from "../pacakge/hall/server/hall/hall_serve";
import GameServer from "../pacakge/hall/server/gameserver/game_server";
import Hall from "../pacakge/hall/module/hall/hall";
import AudioManager from "./audio_manager";
import LoginModule from "../pacakge/hall/module/login/login_module";
import UserDataManager from './user_manager';
import ModelData from '../pacakge/public/model_data';
import NotifyServer from '../pacakge/hall/server/notify/notify_server';
import HallServerNotify from '../pacakge/hall/server/hallnotify/hall_serve_notify';
import ChatShowEmoji from "../pacakge/table/module/tablechat/chat_show_emoji";
import Utility from '../utility/utility';
import TextureManager from "./texture_manager";
import PlayerEffectModule from "../pacakge/public/module/player_effect/player_effect";
import { GameManager } from "./game_manager";
import ClubHallModule from "../pacakge/club/hall/club_hall_module";
import LoaclStorage from "./local_storage";
import { club_utils } from '../pacakge/club/club_utils';



//场景跳转
export default class SceneManager {
    
    static tableModuleName = '';

    static tableModuleNeedNames = [];

    static lastEntranceOpenModuleName = ""

    //是否有场景跳转
    static transitionCount = 0

    static loadingTableModule(data, onFinish?: (tableModuleName) => void) {
        let self = this;
        let lastTableModuleName = this.tableModuleName
        this.tableModuleNeedNames = AppData.gameNameToTableModule[AppData.gameSimpleName]
        if (this.tableModuleNeedNames == null) {
            cc.error("错误的GameName", AppData.gameSimpleName)
            return
        }
        this.tableModuleName = AppData.gameNameToTableModule[AppData.gameSimpleName][0]
        //为了避免之前的模块没打开，后面的模块又打开了
        if (lastTableModuleName != '' && lastTableModuleName != this.tableModuleName) {
            ModuleManager.instance.destroyModule(lastTableModuleName)
        }
        // cc.sys.localStorage.setItem("LATELY_GAME", AppData.gameSimpleName)

        ModuleManager.instance.removeModule(this.tableModuleName)
        ModuleManager.instance.showModule(ChatShowEmoji, null)
        AudioManager.instance.stopAllMusic()
        ModuleManager.instance.showModuleName(this.tableModuleName, data, () => {
            UserDataManager.clearGetCurrencyDataState()
            ModuleManager.instance.hideAllModule(self.tableModuleNeedNames)
            ModuleManager.instance.destroyAllModule(self.tableModuleNeedNames, AppData.memoryRecyclingLevel > 1)            
            ModuleManager.instance.showModule(PlayerEffectModule)
            ModuleManager.instance.destroyRemoveModule(self.tableModuleName)
            if (onFinish) {
                onFinish(self.tableModuleName)
            }
            
            AppData.inTable = true;
        })

        TextureManager.instance.clearSpriteCache();

        return this.tableModuleName
    }

    static showHall(intent?, callback?) {
        //必须拿到首次数据后才能进入大厅
        // ModelData.instance.getRequiredData
        AppData.inTable = false;
        ModelData.instance.getRequiredData(() => {
            GameManager.reportConversionEvent("login_requiredata_request_sucess")
            ModuleManager.instance.showModule(Hall, null, () => {
                AppData.alreadyShowHallScene = true
                callback && callback(intent)
                AudioManager.instance.playMusicLoop()
            })
        })
    }

    static gotoHall(intent?) {
        let self = this
        SceneManager.showHall(intent, () => {
            if (intent == "HallServerLoginRspToHall") {
                ModuleManager.instance.hideModule("NetPrompt")
        }
            ModuleManager.instance.destroyModule("LoginModule")
            //ModuleManager.instance.hideModule(self.tableModuleName);
            ModuleManager.instance.destroyModule(self.tableModuleName, false)
        })
    }

    static gotoClubHall(intentData?, callback?) {
        ModelData.instance.getAccountLoginBindData(()=>{
            ModuleManager.instance.showModule(ClubHallModule, intentData, ()=>{
                ModuleManager.instance.hideModule("Hall")
                ModuleManager.instance.hideModule("ClubList")
                ModuleManager.instance.hideModule("NetPrompt")
                LoaclStorage.setNumber("__lastEnterClubId", intentData.userClubId)
                callback && callback()
            });
        })
    }

    static _gotoHallOrClubHall(intent?) { 
        let self = this;
        let lastEnterClubId = LoaclStorage.getNumber("__lastEnterClubId", 0)
        if (lastEnterClubId != 0) {
            club_utils.getUserClubListWithId(lastEnterClubId, (error, data) => {
                if (data) {  //有可能被踢出了俱乐部，所以需要做下异常判断
                    SceneManager.gotoClubHall(data, () => {
                        ModuleManager.instance.destroyModule("LoginModule")
                        if (intent == "TabelExit") {  //重启后直接进入了牌桌，然后再重牌桌中退出
                            ModuleManager.instance.destroyAllModule(self.tableModuleName, AppData.memoryRecyclingLevel > 1);
                            ModuleManager.instance.destroyModule(self.tableModuleName, AppData.memoryRecyclingLevel > 1)
                        }
                    })
                } else {
                    SceneManager.gotoHall(intent)
                }
            })
        } else {
            SceneManager.gotoHall(intent)
        }
        TextureManager.instance.clearSpriteCache();
        ModuleManager.instance.destroyModule("ChatShowEmoji")
        ModuleManager.instance.destroyModule('PlayerEffectModule');
    }

    static gotoHallOrClubHall(intent?) {
        AppData.inTable = false;
        let self = this;
        HallServer.instance.close()
        HallServerNotify.instance.close()
        GameServer.instance.close()
        AudioManager.instance.playMusicLoop()
        UserDataManager.getCurrencyData(ModelData.instance.roleData.id, null, true)
        ModuleManager.instance.hideAllModule(["LoginModule", "HallBase", this.tableModuleName,SceneManager.lastEntranceOpenModuleName])
        if (SceneManager.lastEntranceOpenModuleName != "") {
            let lastEntranceOpenModuleName = SceneManager.lastEntranceOpenModuleName
            SceneManager.lastEntranceOpenModuleName = ""
            ModuleManager.instance.showModuleName(lastEntranceOpenModuleName, "fromTable", (state) => {
                if (intent == "HallServerLoginRspToHall") {
                    ModuleManager.instance.hideModule("NetPrompt")
                }
                ModuleManager.instance.destroyAllModule(self.tableModuleName, AppData.memoryRecyclingLevel > 1);
                ModuleManager.instance.destroyModule(self.tableModuleName, AppData.memoryRecyclingLevel > 1)
            })
            return
        }

        if (intent == "HallServerLoginRspToHall") { //第一次登录,游客登录不能自动进入
            if (!ModelData.instance.loginWithVisitors && ModelData.instance.clubId == 0 && AppData.openInstallData && AppData.openInstallData.clubCode) {
                club_utils.autoJoinClub(AppData.openInstallData.clubCode, (error, joinSucess) => {  //自动加入俱乐部
                    if (joinSucess) {
                        LoaclStorage.setNumber("__lastEnterClubId", AppData.openInstallData.clubId)
                    }
                    SceneManager._gotoHallOrClubHall(intent)
                })
            } else {
                SceneManager._gotoHallOrClubHall(intent)
            }
        } else {
            SceneManager._gotoHallOrClubHall(intent)
        }

    }

    static gotoMatchingTableModule(data, onFinish?: () => void) {
        ModuleManager.instance.showModuleName("TableMatchModule");
    }

    static gotoAuth(logout ?: boolean) {
        AppData.inTable = false;
        ModuleManager.instance.hideModule("NetPrompt")
        HallServer.instance.close()
        HallServerNotify.instance.close()
        NotifyServer.instance.close();
        GameServer.instance.close()
        GameManager.logout()
        AudioManager.instance.stopMusic()
        SceneManager.lastEntranceOpenModuleName = ""
        // ModuleManager.instance.showModule(HallBase,{loginScene:true})
        ModuleManager.instance.showModule(LoginModule)
        ModuleManager.instance.hideAllModule(["HallBase", "LoginModule"])
        if (logout) {
            ModuleManager.instance.destroyModule("Hall")
        }
        ModuleManager.instance.destroyAllModule("LoginModule")
    }

    static loginFromAuth(jsonString: string) {
        ModuleManager.instance.showModuleName("NetPrompt", { showImmediately: true })
        HallServer.instance.accountLogin("", jsonString, "", null, null, 6);
        AppData.getOpeninstallData(false)
    }

    //网络连接故障

    static gotoLink(url){
        let urlData = Utility.urlParse(url)
        if(!urlData){
            return
        }
        if(urlData.protocol == 'http:' || urlData.protocol == 'https:'){
            cc.sys.openURL(url)
        }else{
            if(urlData.protocol == AppData.appName + ':'){
                if(urlData.host == 'module'){
                    let moduleName = urlData.pathname.replace('/', '')
                    if(moduleName != ''){
                        let intentData = urlData.queryMap
                        ModuleManager.instance.showModuleName(moduleName, intentData)
                    }
                }else{//其他可扩展
                    
                }
            }else{
                cc.sys.openURL(url)
            }
        }
    }
}